<template>
  <div class="appeal-status-card" :class="`status-card-${status}`">
    <div class="appeal-status-card-wrapper">
      <div class="appeal-status-card-header">
        <div class="appeal-status-card-header-title">
          <span>
            {{ $t(`appeal_data.status.${status}.text`) }}
          </span>
        </div>
        <div class="appeal-status-card-header-count" v-if="status != 'success' && status != 'cancelled'">
          {{ appeals && appeals.length || 0 }}
        </div>
      </div>
      <div class="appeal-status-card-body">
        <template v-if="appeals && appeals.length > 0">
          <AppealCard v-for="appeal in appeals" :key="appeal.id" :appeal="appeal" :status="status" @openAppeal="openAppeal" />
        </template>
        <template v-else>
          <div class="appeal-status-card-body-empty">
            {{ $t('noinfo') }}
          </div>
        </template>
        <template v-if="!isHideLoadMore">
          <div class="appeal-status-card-body-load-more" v-if="status == 'success' && !loading">
            <v-btn class="btn-loadmore" @click="loadMoreDataSuccess()" :disabled="loading || !isMoreData">
              {{ $t('load_more_data') }} <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
          <div class="appeal-status-card-body-load-more" v-else-if="status == 'cancelled' && !loading">
            <v-btn class="btn-loadmore" @click="loadMoreDataCancelled()" :disabled="loading || !isMoreData">
              {{ $t('load_more_data') }} <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
          <div class="appeal-status-card-body-load-more" v-if="loading">
            <v-progress-circular indeterminate color="green" size="20"></v-progress-circular>
          </div>
        </template>
      </div>
      <template v-if="isFiltering">
        <div class="appeal-status-card-body-filtering">
          <v-progress-circular indeterminate color="green" size="30"></v-progress-circular>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AppealCard from "./AppealCard.component.vue";
export default {
  name: 'AppealStatusCard',
  components: {
    AppealCard
  },
  props: {
    status: {
      type: String,
      required: true
    },
    appeals: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false
    },
    isMoreData: {
      type: Boolean
    },
    isHideLoadMore: {
      type: Boolean,
      default: false
    },
    isFiltering: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {
    openAppeal(mode, appeal) {
      this.$emit('openAppeal', mode, appeal);
    },
    loadMoreDataSuccess() {
      this.$emit('loadMoreDataSuccess');
    },
    loadMoreDataCancelled() {
      this.$emit('loadMoreDataCancelled');
    }
  }
}
</script>

<style lang="scss" scoped>

.appeal-status-card {
  min-width: 395px;
  width: 395px;
  .appeal-status-card-wrapper{
    position: relative;
  }
  .appeal-status-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FCFCFC;
    padding: 10px 20px;
    border-radius: 8px 8px 0 0;
    .appeal-status-card-header-title {
      font-size: 16px;
      font-weight: 500;
    }
    .appeal-status-card-header-count{
      font-size: 14px;
      font-weight: 400;
    }
  }
  .appeal-status-card-body {
    position: relative;
    padding: 14px 16px;
    border-radius: 0 0 8px 8px;
    background-color: #A9A9A933;
    height: calc(100vh - 64px - 64px - 88px - 56.5px - 44px - 20px - 11px);
    min-height: 350px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    &.ovf-hidden {
      overflow-y: hidden !important;
    }
  }
  &.status-card-pending {
    .appeal-status-card-header-title {
      color: var(--v-warning-base);
    }
  }
  &.status-card-waiting {
    .appeal-status-card-header-title {
      color: var(--v-info-base);
    }
  }
  &.status-card-approved {
    .appeal-status-card-header-title {
      color: var(--v-accent-base);
    }
  }
  &.status-card-success {
    .appeal-status-card-header-title {
      color: var(--v-success-base);
    }
  }
  &.status-card-cancelled {
    .appeal-status-card-header-title {
      color: var(--v-error-base);
    }
  }

  .appeal-status-card-body-load-more{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .appeal-status-card-body-empty{
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #777777;
    padding: 20px;
  }
}

.btn-loadmore {
  box-shadow: 0 0 0 0 !important;
  background-color: transparent !important;
  color: #424242;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  margin: 0 auto;
  letter-spacing: 0;
}

.appeal-status-card-body-filtering{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00000040;
  z-index: 2;
  border-radius: 8px;
}
</style>